(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sc-floating-buttons"] && !Shopify.designMode) return;
  try {
    function initSilkCraneFloatingButtons() {
    var roots = document.querySelectorAll('[data-sc-floating-buttons-root]');

    roots.forEach(function(root, index) {
      if (index < roots.length - 1) {
        root.remove();
      }
    });

    if (window.silkCraneFloatingButtonsInitialized) {
      return;
    }

    window.silkCraneFloatingButtonsInitialized = true;

    document.addEventListener('click', function(event) {
      document.querySelectorAll('[data-sc-floating-buttons-root] details[open]').forEach(function(details) {
        if (!details.contains(event.target)) {
          details.removeAttribute('open');
        }
      });
    });

    document.addEventListener('keydown', function(event) {
      if (event.key !== 'Escape') {
        return;
      }

      document.querySelectorAll('[data-sc-floating-buttons-root] details[open]').forEach(function(details) {
        details.removeAttribute('open');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSilkCraneFloatingButtons);
  } else {
    initSilkCraneFloatingButtons();
  }
  } catch(e) { console.error(e); }
})();

})();
